import { BaseRESTService } from '../../common/services/BaseRESTService';

export type LDValueType = string | boolean;

export type LDFlagSet = {
  [key: string]: LDValueType;
};

export type OIDCConfig = {
  endpoint: string;
  buttonLabel: string;
};

export type Account = {
  forgotPassword: string;
  changePassword: string;
};

export type PresetConfig = {
  account: Account | null;
  oidc: OIDCConfig | null;
  featureFlags: LDFlagSet;
  sessionDuration: number;
};

/**
 * Used to retrieve the necessary app configuration, including LaunchDarkly
 * feature flags and login flows availability.
 *
 * See `docs/development-guidelines/feature-flags.md` for guidance on how to
 * add a new feature flag and expose it to the UI.
 */
export class PresetService extends BaseRESTService {
  async getPresets(): Promise<PresetConfig> {
    const response = await this.get('/api/internal/presets', { omitAuthHeader: true });
    return <PresetConfig>response.data;
  }
}
